<template>
    <div class=" bg-gray-100 border-t-2 static bottom-0 w-full px-10 py-5 z-50">
        <div class="grid grid-flow-col text-sm">
            <span class="font-bold">ITSA System <a class="hidden md:block font-normal">(Interactive Teaching and Student
                    Assesment System)</a></span>
            <span class=" place-self-end"><a class="hidden md:block">Created by</a> Livio Macaj @2022</span>
        </div>
    </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
</style>